// East Carolina University's undergraduate majors (#2652). Read on
// 2026-10-01 from ECU's official Degree Explorer (degrees.ecu.edu), which
// lists every degree program with its level, degree and college: every
// Undergraduate program leading to a bachelor's degree is kept (75 entries),
// graduate, doctoral and professional programs left out. Degree names are
// the Degree Explorer's own, written out in full (Bachelor of Science in
// Business Administration, Bachelor of Science in Nursing, ...); a major
// offered as both a BA and a BS appears twice. Quirk: the 2026-2027
// Undergraduate Catalog (catalog.ecu.edu) answered with an AWS WAF challenge
// to both curl and WebFetch, so the Degree Explorer is the list used. The
// KB's majors list was the starting point; the school's list wins.
const majors = {
    "slug": "east-carolina-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in ECU's official Degree Explorer, grouped by the college that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Thomas Harriot College of Arts and Sciences",
            "source": {
                "label": "ECU Degree Explorer, undergraduate programs",
                "url": "https://degrees.ecu.edu/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Applied Sociology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Community and Regional Planning",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Criminal Justice and Criminology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Earth and Atmospheric Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "English",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Foreign Languages and Literatures",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Geography and Geospatial Data Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Multidisciplinary Studies",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Neuroscience",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Philosophy and Religious Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Professional Writing and Information Design",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Security Studies",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "University Studies",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "ECU Degree Explorer, undergraduate programs",
                "url": "https://degrees.ecu.edu/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Hospitality Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Management",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Marketing",
                    "degree": "Bachelor of Science in Business Administration"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "Bachelor of Science in Business Administration"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "ECU Degree Explorer, undergraduate programs",
                "url": "https://degrees.ecu.edu/"
            },
            "majors": [
                {
                    "name": "Elementary Education (K-6)",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Middle Grades Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Secondary Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Special Education",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Engineering & Technology",
            "source": {
                "label": "ECU Degree Explorer, undergraduate programs",
                "url": "https://degrees.ecu.edu/"
            },
            "majors": [
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Construction Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Design",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Distribution and Logistics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Industrial Engineering Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Industrial Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Information and Cybersecurity Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Interior Design and Fashion Merchandising",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Software Engineering",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Fine Arts and Communication",
            "source": {
                "label": "ECU Degree Explorer, undergraduate programs",
                "url": "https://degrees.ecu.edu/"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Art Education",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Communication",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Dance",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Music Education",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "Bachelor of Fine Arts"
                }
            ]
        },
        {
            "name": "College of Health and Human Sciences",
            "source": {
                "label": "ECU Degree Explorer, undergraduate programs",
                "url": "https://degrees.ecu.edu/"
            },
            "majors": [
                {
                    "name": "Birth through Kindergarten (B-K) Professional Studies",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Child Life",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Clinical Laboratory Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Environmental Health",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Exercise Physiology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Family and Community Services",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Health Information Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Health Services Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Nutrition and Dietetics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Physical Education and Coaching Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Public Health",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Recreation, Park, and Sport Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Recreational Therapy",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Rehabilitation Services",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Social Work",
                    "degree": "Bachelor of Social Work"
                },
                {
                    "name": "Speech and Hearing Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Sport Performance Science",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "ECU Degree Explorer, undergraduate programs",
                "url": "https://degrees.ecu.edu/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "Bachelor of Science in Nursing"
                }
            ]
        }
    ]
};

export default majors;
